import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type { AppDto, AppListRequest, CreateAppRequest, UpdateAppRequest } from '@/types/app';

export const appsApi = {
  list(request: AppListRequest = {}): Promise<PagedResult<AppDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<AppDto>>>('/apps', { params: request }));
  },
  getById(id: number): Promise<AppDto> {
    return unwrap(apiClient.get<ApiResponse<AppDto>>(`/apps/${id}`));
  },
  create(request: CreateAppRequest): Promise<AppDto> {
    return unwrap(apiClient.post<ApiResponse<AppDto>>('/apps', request));
  },
  update(id: number, request: UpdateAppRequest): Promise<AppDto> {
    return unwrap(apiClient.put<ApiResponse<AppDto>>(`/apps/${id}`, request));
  },
  toggleApproval(id: number, isApprovedInPlay: boolean): Promise<AppDto> {
    return unwrap(apiClient.post<ApiResponse<AppDto>>(`/apps/${id}/toggle-approval`, { isApprovedInPlay }));
  },
  deactivate(id: number): Promise<void> {
    return apiClient.delete(`/apps/${id}`).then(() => undefined);
  },
  reactivate(id: number): Promise<void> {
    return apiClient.post(`/apps/${id}/reactivate`).then(() => undefined);
  },
};
